import React from 'react';
import { testimonials } from '../data/testimonials';
type ClientProofProps = {
  index?: number;
  className?: string;
};

/** Short verbatim client line, placed beside calls to action. */
export function ClientProof({
  index = 0,
  className = ''
}: ClientProofProps) {
  const t = testimonials[index % testimonials.length];
  return <figure className={`flex items-start gap-4 ${className}`} data-id="element-122" data-mp="2x29829wlck1v">
      <span aria-hidden="true" className="mt-3 h-px w-8 shrink-0 bg-gold" data-id="element-123" data-mp="3kr0vyp35eg8u" />
      <div data-id="element-124" data-mp="3pqdl5ghhrzel">
        <blockquote className="font-serif text-[1.2rem] italic leading-snug text-charcoal" data-id="element-125" data-mp="3pqx1wtveohr1">“{t.excerpt}”</blockquote>
        <figcaption className="t-label mt-2 text-[0.62rem] text-graphite" data-id="element-126" data-mp="3bpkksf4iea3k">
          {t.name}, {t.location}
        </figcaption>
      </div>
    </figure>;
}